import React from "react";
import TripBodyDetailed from "../TripBodyDetailed";
import BaggageFeesLink from "../BaggageFeesLink";
import Card from "../Card";

const TripSummary = ({
  // isRoundTrip,
  baggageFeesUrlDeparting,
  baggageFeesUrlReturning,
  dateDisplayDepartingTrip,
  dateDisplayReturningTrip,
  departingTripSegments,
  returningTripSegments
}) => (
  <Card>
    <h3>Trip Summary</h3>
    <TripBodyDetailed
      tripSegments={departingTripSegments}
      departureDateDisplay={dateDisplayDepartingTrip}
    />
    <BaggageFeesLink baggageFeeUrl={baggageFeesUrlDeparting} />
    {!!returningTripSegments && (
      <React.Fragment>
        <TripBodyDetailed
          tripSegments={returningTripSegments}
          departureDateDisplay={dateDisplayReturningTrip}
        />
        <BaggageFeesLink baggageFeeUrl={baggageFeesUrlReturning} />
      </React.Fragment>
    )}
  </Card>
);

export default TripSummary;



// WEBPACK FOOTER //
// ./src/components/TripSummary/index.js